import { getFirebase } from './firebase';
var analytics = getFirebase().analytics();
export default analytics;